import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 30,
  medium: 17,
  small: 10,
  xSmall: 10
};
const CloseIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  const renderIcon = () => {
    switch (size) {
      case "large":
        return /* @__PURE__ */ React.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 40 40",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ React.createElement(
            "path",
            {
              d: "M20.3521 20.0021L33.7871 6.56709L33.08 5.85999L19.645 19.295L6.91707 6.56709L6.20996 7.2742L18.9379 20.0021L6.20996 32.73L6.91707 33.4371L19.645 20.7092L33.08 34.1443L33.7871 33.4371L20.3521 20.0021Z",
              fill: "currentColor"
            }
          )
        );
      case "xSmall":
        return /* @__PURE__ */ React.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 16 16",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ React.createElement("path", { d: "M3.70428 3L12.8599 12.2857L12.1556 13L3 3.71429L3.70428 3Z", fill: "currentColor" }),
          /* @__PURE__ */ React.createElement("path", { d: "M12.2957 3.00001L3.1401 12.2857L3.84438 13L13 3.71429L12.2957 3.00001Z", fill: "currentColor" })
        );
      case "small":
        return /* @__PURE__ */ React.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 20 20",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ React.createElement("path", { d: "M5.70428 5L14.8599 14.2857L14.1556 15L5 5.71429L5.70428 5Z", fill: "currentColor" }),
          /* @__PURE__ */ React.createElement("path", { d: "M14.2957 5.00001L5.1401 14.2857L5.84438 15L15 5.71429L14.2957 5.00001Z", fill: "currentColor" })
        );
      case "medium":
      default:
        return /* @__PURE__ */ React.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 30 30",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ React.createElement(
            "path",
            {
              d: "M14.7609 15.4999L7 22.9245L7.73913 23.6316L15.5 16.207L23.2609 23.6316L24 22.9245L16.2391 15.4999L24 8.07527L23.2609 7.36816L15.5 14.7928L7.73913 7.36816L7 8.07527L14.7609 15.4999Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ React.createElement(
            "path",
            {
              d: "M14.7609 15.4999L7 22.9245L7.73913 23.6316L15.5 16.207L23.2609 23.6316L24 22.9245L16.2391 15.4999L24 8.07527L23.2609 7.36816L15.5 14.7928L7.73913 7.36816L7 8.07527L14.7609 15.4999Z",
              fill: "currentColor"
            }
          )
        );
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, renderIcon());
};
CloseIcon.iconName = "CloseIcon";

export { CloseIcon };
